import type { CmtsSession } from "./cmtsSessionTypes.js";

export function formatCmtsTenantDisplay(session: Pick<CmtsSession, "tenantName" | "tenantCode" | "tenantId"> | null | undefined): string {
  if (!session) return "Session tenant unavailable";
  const code = session.tenantCode || session.tenantId;
  const name = session.tenantName || code;
  return code && name ? `${name} (${code})` : "Session tenant unavailable";
}

export function formatCmtsScopeDisplay(session: CmtsSession): string {
  const parts: string[] = [];
  if (session.departmentIds.length) parts.push(`Departments: ${session.departmentIds.join(", ")}`);
  if (session.customerIds.length) parts.push(`Customers: ${session.customerIds.join(", ")}`);
  if (session.supplierIds.length) parts.push(`Suppliers: ${session.supplierIds.join(", ")}`);
  parts.push(`Clearance: ${session.confidentialityClearance}`);
  return parts.join(" · ");
}
